import { render, staticRenderFns } from "./OrdersCRM.vue?vue&type=template&id=608937b9&scoped=true&lang=pug"
import script from "./OrdersCRM.vue?vue&type=script&lang=js"
export * from "./OrdersCRM.vue?vue&type=script&lang=js"
import style0 from "./OrdersCRM.vue?vue&type=style&index=0&id=608937b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608937b9",
  null
  
)

export default component.exports